/* eslint-disable camelcase */
import { Operation } from "@apollo/client";
import moment from "moment";

import { AccountTypeProps } from "../../Store";
import { decodeJWT } from "../../Utils";
import { env } from "../../Constants/env";

import {
  setHubAccessTokenAPI,
  setUserRefreshTokenAPI,
  setLegalPersonTokenAPI,
} from "./Graphql.restApi";
interface SetHeadersReturnProps {
  headers?: {
    client_id?: string;
    client_secret?: string;
    Authorization?: string;
  };
}

export function setHeaders(
  operation: Operation,
  oldHeaders: {},
  updatedJwt: {
    hubAccessToken?: string;
    userAccessToken?: string;
    legalPersonAccessToken?: string;
  },
  tokens: {
    userAccessToken?: string;
    hubAccessToken?: string;
    personalAccessToken?: string;
  },
  accountType: AccountTypeProps
): SetHeadersReturnProps {
  const { operationName } = operation;

  const headers: any = {
    ...oldHeaders,
  };

  switch (operationName) {
    case "SignInOAuth2":
      return headers;

    case "SetAuthentication":
      if (operation.variables?.type === "hub") {
        headers.client_id = env.graphql.clientId;
        headers.client_secret = env.graphql.clientSecret;
      }
      return headers;

    case "CellcardVerifyDocument":
    case "SignIn":
    case "RefreshToken":
    case "MigrateTokenFromAplic":
    case "VerifyEvents":
    case "RequestEvents":
    case "ResetPassword":
    case "CreateProposal":
    case "DeleteProposal":
    case "SendProposalStep":
    case "UpdateProposalStep":
    case "GetLegalTerms":
    case "ListScreenCampaings":
      headers.Authorization =
        updatedJwt?.hubAccessToken || tokens?.hubAccessToken;
      return headers;

    case "GetTokenLegalPerson":
      headers.Authorization =
        updatedJwt?.userAccessToken || tokens?.userAccessToken;
      return headers;

    case "CreateTransaction":
    case "ConfirmTransaction":
    case "RefundTransaction":
    case "CreateConfirmTransactionPIN":
    case "TopupsTV":
    case "TopupsPIN":
    case "TopupsTRANSPORT":
    case "CreateBillCashIn":
    case "GetTransactions":
    case "ListProviders":
    case "ListPortfolio":
    case "GetAccounts":
    case "GetBills":
    case "GetBill":
    case "MutationGetBill":
    case "GetBalanceHistory":
    case "ListSimCardsProducts":
    case "RequestSimCardsOrder":
    case "GetCheckingAccounts":
    case "CreatePayment":
    case "CreatePIXCashIn":
    case "SubscribePIXCashIn":
    case "ApprovePayment":
    case "CreateCheckingAccountsCashIn":
    case "MutationGetCheckingBill":
    case "TopupsLOAN":
    case "RefoundPayment":
    case "GetTransaction":
    case "ListSimCardsOrders":
    case "DeleteSimCardsOrder":
    case "UpdateSimCardsOrder":
    case "GetPaymentDetails":
    case "GetProviderLogos":
    case "UpdateAccountProfile":
    case "TopupsCELLPHONE":
    case "TopupsRAFFLES":
    case "TopupsINSURANCE":
    case "CheckAvailableLoan":
    case "GetProvidersAdditionalInformation":
    case "ListProvidersWithCustomFields":
      headers.Authorization =
        accountType === "naturalPerson"
          ? updatedJwt?.userAccessToken || tokens?.userAccessToken
          : updatedJwt?.legalPersonAccessToken || tokens?.personalAccessToken;
      return headers;

    default:
      console.log("===========//===========");
      console.warn("===========//===========");
      console.log("CADASTRAR QUERY/MUTATION");
      console.warn("CADASTRAR QUERY/MUTATION");
      return headers;
  }
}

export const verifyExpiredToken = (accessToken?: string): boolean => {
  if (!accessToken) {
    console.log("Without Acess_Token");
    return false;
  }

  const { exp } = decodeJWT(accessToken);

  const timestamp = 1000 * Number(exp);
  const isExpired = moment(timestamp).isBefore();

  console.log("Acess_Token", new Date(timestamp));
  console.log("Data Agora", new Date());
  console.log("Expirado", isExpired);

  return isExpired;
};

export const isTokenExpired = ({
  hubAccessToken,
  userAccessToken,
  legalPersonAccessToken,
}: {
  hubAccessToken?: string;
  userAccessToken?: string;
  legalPersonAccessToken?: string;
}): boolean => {
  // console.log("Verify Access Token HUB", hubAccessToken);
  const isExpiredHubAccessToken = verifyExpiredToken(hubAccessToken);

  // console.log("Verify Access Token USER", userAccessToken);
  const isExpiredUserAccessToken = verifyExpiredToken(userAccessToken);

  // console.log("Verify Access Token LEGAL PERSON", legalPersonAccessToken);
  const isExpiredLegalPersonAccessToken = verifyExpiredToken(
    legalPersonAccessToken
  );

  if (isExpiredHubAccessToken) {
    console.log("isTokenExpired HUB");
    return true;
  }

  if (isExpiredUserAccessToken) {
    console.log("isTokenExpired USER");
    return true;
  }

  if (isExpiredLegalPersonAccessToken) {
    console.log("isTokenExpired LEGAL PERSON");
    return true;
  }

  // verificar se pj está expirado

  return false;
};

// receber os tres tokens
export const setTokens = async ({
  hubAccessToken,
  userAccessToken,
  legalPersonAccessToken,
  userJWTRefreshToken,
}: {
  hubAccessToken?: string;
  userAccessToken?: string;
  legalPersonAccessToken?: string;
  userJWTRefreshToken?: string;
}): Promise<any> => {
  let updateHubAcessToken;
  let updateUserAcessToken;
  let updateLegalPersonAcessToken;

  // Get Hub Token

  // se hub expirado
  if (verifyExpiredToken(hubAccessToken)) {
    try {
      const responseHubToken = await setHubAccessTokenAPI().then((resp) =>
        resp.json()
      );

      updateHubAcessToken = responseHubToken?.data?.SetAuthentication;
    } catch (error: any) {
      console.log("Error - SetHubAccessToken", { ...error });
      return error;
    }
  }

  // Get User Token
  if (verifyExpiredToken(userAccessToken)) {
    try {
      //update hub or actual hub jwt
      const useHubAccessToken =
        updateHubAcessToken?.access_token || hubAccessToken;

      const responseUserToken = await setUserRefreshTokenAPI({
        hubJWTAccessToken: useHubAccessToken,
        userJWTRefreshToken,
      }).then((resp) => resp.json());

      updateUserAcessToken = responseUserToken?.data?.RefreshToken;
    } catch (error: any) {
      console.log("Error - SetUserAccessToken", { ...error });
      return error;
    }
  }

  // TODO - Verificar se está usando o perfil pj
  if (verifyExpiredToken(legalPersonAccessToken)) {
    try {
      const useUserAccessToken =
        updateUserAcessToken?.access_token || userAccessToken;

      const responseLegalPersonToken = await setLegalPersonTokenAPI({
        userJWTAccessToken: useUserAccessToken,
      }).then((resp) => resp.json());

      updateLegalPersonAcessToken =
        responseLegalPersonToken?.data?.GetTokenLegalPerson;
    } catch (error: any) {
      console.log("Error - SetLegalPersonAccessToken", { ...error });
      return error;
    }
  }

  // Chamar jwt pj

  return {
    hubJWT: updateHubAcessToken,
    userJWT: updateUserAcessToken,
    legalPersonJWT: updateLegalPersonAcessToken,
  };
};
